/**
 * Pills cloud of brand names, with optional heading.
 * - `brands` : string array.
 * - `title` (optional) : if provided, renders an `<h2>` with a divider.
 * - `intro` (optional) : supporting paragraph.
 * - `bgClassName` (optional) : background class for the outer section.
 */
export default function BrandsCloud({ brands, title, intro, bgClassName }) {
    const inner = (
        <>
            {title && <div className="divider-amber mb-5" />}
            {title && <h2 className="heading text-2xl lg:text-3xl font-extrabold">{title}</h2>}
            {intro && <p className="mt-3 text-[var(--ink-soft)]">{intro}</p>}
            <div className={`flex flex-wrap gap-2.5 ${title ? "mt-8" : "mt-6"}`}>
                {brands.map((b) => (
                    <span key={b} className="inline-flex items-center px-4 py-2 rounded-full bg-white border border-[var(--line)] text-sm font-medium text-[var(--navy)]">
                        {b}
                    </span>
                ))}
            </div>
        </>
    );

    if (bgClassName) {
        return (
            <section className={bgClassName}>
                <div className="max-w-7xl mx-auto px-5 lg:px-10 py-14">{inner}</div>
            </section>
        );
    }
    return (
        <section className="max-w-7xl mx-auto px-5 lg:px-10 py-14">{inner}</section>
    );
}
